<template>
	<div class="price-control">
		<b-container class="bv-example-row">
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
						<span>
							<h5>{{$t('sidebar.pos.PriceControl')}}</h5>
						</span>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="row" v-for="(item, index) in priceControlArray" :key="index">
							<div class="col-sm-4">
								<b-form-group
									label-size="sm"
									class="required"

									label-for="lastName">
									<label class="lebeltop">{{$t('priceControl.pricePercent')}}</label>

									<b-form-input size="sm" :placeholder="$t('pos.sum')"

												  type="number"
												  id="amount"
												  ref="amountRef"
												  @change="inputChanged(item,'pricePercent')"
												  v-model="item.pricePercent"/>
								</b-form-group>
								<label class="text-danger">{{ 100 + '%' + ' -> ' + (100 + parseFloat(item.pricePercent != '' ? item.pricePercent : 0)) + '%'}}</label>
							</div>
							<div class="col-sm-4">
								<b-form-group
									label-size="sm"
									class="required"
									label-for="lastName">
									<label class="lebeltop">{{$t('priceControl.wholesalePercent')}}</label>

									<b-form-input size="sm" :placeholder="$t('promo-to-product.percentage')"
												  type="number"
												  id="percentage"
												  :required="true"
												  ref="percentageRef"
												  @change="inputChanged(item,'wholesalePercent')"
												  v-model="item.wholesalePercent"/>
								</b-form-group>
								<label class="text-danger">{{ 100 +'%' + ' -> ' + (100 + parseFloat(item.wholesalePercent != '' ? item.wholesalePercent : 0)) + '%'}}</label>
							</div>
							<div class="col-sm-2">
								<label class="lebeltop">{{$t('priceControl.departments')}}</label>

								<b-form-select
									v-model="item.departmentId"
									:id="'departmentId-' + index"
									name="departmentId"
									size="sm"
									@change="depChanged(item,index)"

								>
									<option v-for="(selectOption, indexOpt) in departments"
											:key="indexOpt"
											:value="selectOption.id"
											:disabled="checkDepartment(selectOption.id)"
									>
										{{ selectOption.name }}
									</option>
									<template slot="first">
										<option :value="null" disabled>-- {{ $t('priceControl.departments') }} --</option>
									</template>
								</b-form-select>
							</div>
							<div class="col-2" v-if="index != 0">

								<i class="fa fa-remove" style="color:red;padding-top: 34px;cursor: pointer"
								   @click="deleteEvent(item,index)"></i>
							</div>
						</div>
					</div>
				</div>
				<div class="col-sm-5 float-right">
					<div class="row">
						<div class="col-5">
							<b-button variant="btn btn-info" size="sm" block @click="addClck">
								{{$t('client.newClient')}}
							</b-button>
						</div>
						<div class="col-5">
							<b-button variant="btn btn-success" :disabled="sbm_button" block size="sm" @click="saveClick">{{$t('actions.save')}}
							</b-button>
						</div>
					</div>
				</div>
			</b-card>
		</b-container>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import  {TokenService } from "../../services/storage.service";
	import UsersService from "../../services/users.sevice";
	import PosService from "../../services/pos.service";
	import axios from 'axios'
	export default {
		name: "PriceControl",
		data() {
			return {
				priceControlArray: [{
					pricePercent: 0,
					wholesalePercent: 0,
					departmentId: null
				}],
				departments: [],
				arrayFinish: [],
				selectedDeps:[],
				sbm_button: false,
			}

		},
		methods: {
			addClck() {
				this.priceControlArray.push({
					pricePercent: 0,
					wholesalePercent: 0,
					departmentId: null
				});
			},
			async saveClick(){
				let valid = this.checkValidityInputs();
				if( valid === true){
					this.sbm_button = true;
					await this.axios.post(`/pricing/create-percent`,this.priceControlArray).then(response =>{
						let vm = this;
						 setTimeout(function(){
							vm.sbm_button = false;
							 vm.$vs.notify({
								 title: vm.$t('Changes saved successfully.'),
								 color: 'success',
								 icon: 'close',
								 position: 'top-right'
							 });
						},2500);


					}).catch(error =>{

					});
				}else{
					valid.forEach(function(el){
						let obj = document.getElementById('departmentId-' + el);
						obj.classList.add('is-invalid');
					});
					this.$vs.notify({
						title: this.$t('Please select department!'),
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}


			},
			 deleteEvent(item, index) {
				 this.priceControlArray.splice(index, 1);


			},
			async getDeps()
			{
				await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
					this.departments =  response.data.permittedDepartments
				})
			},
			async getPricingList()
			{
				await PosService.getPricingList().then(response => {
					if(response.data.length !== 0)
						this.priceControlArray = response.data;
				})
			},
			checkValidityInputs()
			{
				let collection = [];
				this.priceControlArray.filter(function (arr,index){
					if(arr.departmentId == null){
						collection.push(index);
					}
				});
				return collection.length === 0 ? true : collection;

			},

			checkDepartment(id)
			{
				return this.selectedDeps.includes(id) ? true : false;

			},
			inputChanged(item,attr){
				if(item[attr] === ''){
					item[attr] = 0
				}
			},

			depChanged(item,index)
			{
				let obj = document.getElementById('departmentId-' + index);
				obj.classList.remove('is-invalid');

			}



		},
		watch: {
			priceControlArray: {
				deep: true,
				handler(newVal) {
					var arry = [];
					newVal.forEach(function(val){
						if(val.departmentId != null){
							if(!arry.includes(val.departmentId)){
								arry.push(val.departmentId)
							}
						}
					})
					this.selectedDeps = arry;
				}
			}
		},

		mounted(){
			this.getDeps();
			this.getPricingList();

		},
		components: {
			Multiselect,
		},
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
